import type React from 'react';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { useScrollToTop } from '@shared/hooks/useScrollToTop';
import { ListBody, PageHead, PageTitle } from '@shared/ui';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import * as st from './styles.module.scss';

const getTitle = (mode: string) => {
  switch (mode) {
    case 'video':
      return 'Описание видео';
    case 'comment':
      return 'Комментарий специалиста';
  }
  return 'Неизвестный тип';
};

export const ProgramDescVideo: React.FC = () => {
  const location = useLocation();
  const { description, about, mode } = location.state;

  useScrollToTop();

  const pageTitle = useMemo(() => getTitle(mode), [mode]);

  return (
    <>
      <PageTitle title={pageTitle} />
      <PageHead Left={<PageBackButton />} />

      <ListBody>
        {mode !== 'comment' && <h1 className={st.name}>{about}</h1>}
        <DescriptionViewer
          className={mode === 'comment' ? st.comment : undefined}
          description={description}
          isAlwaysFull
        />
      </ListBody>
    </>
  );
};
